import React from 'react';
import { LoadingPanel } from './';

interface LoadingProps {
    isLoading: boolean;
    top?:number;
    left?:number;
}

const Loading: React.FC<LoadingProps> = ({ isLoading, top,left, children }) => {
    if (isLoading) return <LoadingPanel top={top} left={left}/>;

    return <>{children}</>;
};

export default Loading;
